import React from 'react'
import { useController } from 'react-hook-form'

import SwitchButton from './SwitchButton'

const SwitchButtonField = ({
    control,
    name,
    rules,
    onChange,
    defaultValue = false,
    ...otherProps
}) => {
    const {
        field: { ref, value, onChange: onChangeForm, ...otherFields }
    } = useController({
        control,
        name,
        rules,
        defaultValue
    })

    const handleChange = (e) => {
        onChangeForm(e.target.checked)
        onChange(e.target.checked)
    }

    return (
        <SwitchButton
            ref={ref}
            {...otherProps}
            {...otherFields}
            checked={value}
            onChange={handleChange}
        />
    )
}

SwitchButtonField.defaultProps = {
    onChange: () => {}
}

export default SwitchButtonField
